import { useGame } from "../store";
import { fileUrl } from "../lib/paths";

/** Fullscreen overlay for opened files (PDFs in an iframe, images inline). */
export function PdfOverlay(): React.ReactElement | null {
  const pdf = useGame((s) => s.pdf);
  const closePdf = useGame((s) => s.closePdf);
  if (!pdf || pdf.pages.length === 0) return null;

  const page = pdf.pages[0]!;
  const url = fileUrl(page);
  const isPdf = page.toLowerCase().includes(".pdf");

  return (
    <div className="overlay" onClick={closePdf}>
      <button className="btn overlay__close" onClick={closePdf}>
        Close
      </button>
      {isPdf ? (
        <iframe title="document" src={url} onClick={(e) => e.stopPropagation()} />
      ) : (
        <img src={url} alt="" onClick={(e) => e.stopPropagation()} />
      )}
    </div>
  );
}
